/** KAN-835: тексты блока "Уведомления" приложения менеджера (/m/profile). */

export const PUSH_TEXTS = {
  enable: 'Включить уведомления',
  on: 'Включены',
  disable: 'Выключить',
  iosInstall:
    'Сначала добавьте приложение на экран Домой: нажмите Поделиться, затем "На экран Домой". Уведомления включаются в установленном приложении.',
  denied:
    'Уведомления запрещены. Разрешите их в настройках телефона: Настройки, Уведомления, это приложение (или в настройках сайта в браузере), затем вернитесь сюда.',
  unsupported:
    'Этот браузер не поддерживает уведомления. Откройте приложение в Chrome или установите его на экран Домой.',
  hint: 'Придёт уведомление, когда клиент требует внимания.',
  /** KAN-845: с включённым VPN подписка на push не проходит (проверено владельцем). */
  vpnNote: 'Перед включением выключите VPN, иначе телефон не подключится к уведомлениям.',
  /** KAN-845: браузер не смог подписаться у службы push (Android: "push service error"). */
  pushServiceError:
    'Телефон не смог подключиться к службе уведомлений Google. Выключите VPN, проверьте, что Chrome разрешено показывать уведомления (Настройки телефона, Приложения, Chrome, Уведомления), отключите экономию заряда для Chrome и нажмите ещё раз. Если не получится, подключите Telegram ниже.',
  subscribeFailed: 'Не удалось включить уведомления на этом устройстве. Нажмите ещё раз.',
};

/**
 * KAN-845: текст для пользователя, когда PushManager.subscribe упал.
 * Сырой текст браузера (английский) пользователю не показываем.
 */
export function pushSubscribeErrorText(error: unknown): string {
  const name = error instanceof Error || error instanceof DOMException ? error.name : '';
  const message = error instanceof Error || error instanceof DOMException ? error.message : String(error ?? '');
  if (name === 'AbortError' || /push service/i.test(message)) return PUSH_TEXTS.pushServiceError;
  // Свои ошибки webPush уже по-русски (например, не запустилась фоновая служба).
  if (/[а-яё]/i.test(message)) return message;
  return PUSH_TEXTS.subscribeFailed;
}

export const TELEGRAM_TEXTS = {
  connect: 'Подключить Telegram',
  linked: 'Telegram подключён',
  disconnect: 'Отключить',
  botMissing: 'Бот для менеджеров ещё не подключён на платформе. Обратитесь к владельцу кабинета.',
  hint: 'После нажатия откроется Telegram: нажмите "Запустить" в боте.',
};
